<template>
  <div class="r-appointment-modal">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("customer.addAppointment") }}</div>
        <div class="individual-account">
          {{ $t("customer.customerManagement") }}
        </div>
        <div
          class="
            input-box
            common-flex common-align-center common-justify-between
          "
          style="margin-bottom: 45px"
        >
          <div>{{ $t("customer.appointmentDate") }}</div>
          <DatePicker
            v-model="appointmentDate"
            :placeholder="$t('customer.selectTip')"
            style="width: 200px"
            @on-change="changeDate"
          ></DatePicker>
        </div>
        <div
          class="
            input-box
            common-flex common-align-center common-justify-between
          "
          style="margin-bottom: 137px"
        >
          <div>{{ $t("customer.Content") }}</div>
          <input
            v-model="params.content"
            :placeholder="$t('customer.please…')"
            style="width: 200px"
            type="text"
          />
        </div>

        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="show=false">
            {{ $t("password.back") }}
          </div>
          <div class="submit common-hover" @click="submit">
            {{ $t("password.submit") }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-appointment-modal",
  data() {
    return {
      show: false,
      appointmentDate: "",
      params: {
        appointmentDate: "",
        content: "",
        type: "1",
        customerId: "",
        id: "",
      },
      // params.customerId
    };
  },
  watch: {
    appointmentShow: {
      handler(newval, oldval) {
        this.show = newval;
      },
      immediate: true,
    },
    editAppointment: {
      handler(newval, oldval) {
        console.log('newval',newval)
        // 如果是编辑
        if (newval) {
          this.params.appointmentDate = this.appointmentDetails.appointmentDate;
          this.appointmentDate = this.appointmentDetails.appointmentDate;
          this.params.content = this.appointmentDetails.content;
          this.params.id = this.appointmentDetails.id;
          // this.appointmentDetails
        } else {
          //新增的话
          this.params.appointmentDate = ''
          this.params.content = ''
          this.params.id = ''
          this.appointmentDate = ''
        }
      },
      immediate: true,
    },
    appointmentDetails: {
      handler(newval, oldval) {
        console.log('newval',newval)
        // 如果是编辑
        if(this.editAppointment){
          this.params.appointmentDate = newval.appointmentDate;
          this.appointmentDate = newval.appointmentDate;
          this.params.content = newval.content;
          this.params.id = newval.id;
        }
      },
      immediate: true,
    },
    
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerAppointmentShow", newval);
        }
      },
      immediate: true,
    },
    customerId: {
      handler(newval, oldval) {
        this.params.customerId = newval;
      },
      immediate: true,
    },
  },
  mounted() {
    console.log("this.customerId", this.customerId);
  },
  props: {
    customerId: [Number, String],
    appointmentShow: Boolean,
    // 是否是编辑
    editAppointment: Boolean,
    // 编辑带过来的信息
    appointmentDetails: [Object,String],
  },
  methods: {
    ...mapActions([
      "saveCustomerNoteAction", //保存预约信息
    ]),
    // 修改日期
    changeDate(e) {
      console.log("e", e);
      this.params.appointmentDate = e;
    },
    // 提交预约
    submit() {
      this.saveCustomerNoteAction(this.params).then((res) => {
        console.log("res", res);
        if (res.code == 0) {
          this.$emit("submitAppointment");
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
// .r-appointment-modal{
/deep/.ivu-input {
  border: none;
}
/deep/.ivu-input-suffix {
  display: none;
}
.password-box {
  height: 418px;
  width: 620px;
  padding: 14px 24px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .current-balance {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
  }
  .current-price {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    font-family: Times, Times-Bold;
    color: #000000;
    line-height: 37px;
    margin-bottom: 3px;
  }
  .individual-account {
    font-size: 12px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: left;
    color: #666666;
    line-height: 14px;
    margin-bottom: 50px;
  }
  .input-box {
    height: 32px;
    width: 372px;
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    margin-bottom: 45px;
    padding-bottom: 12px;
    div {
      width: 120px;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 16px;
    }
    input {
      height: 20px;
      line-height: 20px;
      margin-left: 70px;
      border: none;
      outline: none;
    }
  }
}
// }
</style>


// WEBPACK FOOTER //
// src/components/r-appointment-modal.vue